import useKey from './useKey';
export default function useEsc(callback) {
  useKey(function (event) {
    return event.key === 'Escape' && callback(event);
  });
}